<template>
    <section class="zemlya-banners">
        <a class="zemlya-banners__left" :href="bannerInfo.main.props.link.value">
            <picture class="zemlya-banners__picture">
                <source
                    media="(max-width: 600px)"
                    :srcset="bannerInfo?.main?.props?.img_mobile?.files[0]?.src"
                >
                <source
                    media="(max-width: 1100px)"
                    :srcset="bannerInfo?.main?.props?.img_table?.files[0]?.src"
                >
                <source
                    media="(min-width: 1101px)"
                    :srcset="bannerInfo?.main?.props?.img_desktop?.files[0]?.src"
                >

                <img 
                    :src="bannerInfo?.main?.props?.img_desktop?.files[0]?.src"
                    alt="background-left-photo"
                    class="zemlya-banners__image"
                >
            </picture>
            <div class="zemlya-banners__left-content zemlya-banners__content">
                <h1 class="zemlya-banners__left-title">
                    {{ bannerInfo.main.props.title.value }}
                </h1>
                <p class="zemlya-banners__left-text">
                    {{ bannerInfo.main.props.subtitle.value }}
                </p>
                <a 
                    class="zemlya-banners__left-link" 
                    :href="bannerInfo.main.props.link.value"
                >
                    {{ bannerInfo.main.props.link.description }}
                </a>
            </div>
        </a>
        <div class="zemlya-banners__right">
            <a class="zemlya-banners__right-block" :href="bannerInfo.right_top.props.link.value">
                <picture class="zemlya-banners__picture">
                    <source
                        media="(max-width: 600px)"
                        :srcset="bannerInfo?.right_top?.props?.img_mobile?.files[0]?.src"
                    >
                    <source
                        media="(max-width: 1100px)"
                        :srcset="bannerInfo?.right_top?.props?.img_table?.files[0]?.src"
                    >
                    <source
                        media="(min-width: 1101px)"
                        :srcset="bannerInfo?.right_top?.props?.img_desktop?.files[0]?.src"
                    >

                    <img 
                        :src="bannerInfo?.right_top?.props?.img_desktop?.files[0]?.src"
                        alt="background-right-top-photo"
                        class="zemlya-banners__image"
                    >
                </picture>
                <div class="zemlya-banners__right-content zemlya-banners__content">
                    <h2 class="zemlya-banners__right-title">
                        {{ bannerInfo.right_top.props.title.value }}
                    </h2>
                    <div class="zemlya-banners__right-container">
                        <p class="zemlya-banners__right-text">
                            {{ bannerInfo.right_top.props.subtitle.value }}
                        </p>
                        <a class="zemlya-banners__right-link" :href="bannerInfo.right_top.props.link.value">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7933 8.48011C14.0689 8.21495 14.0689 7.78505 13.7933 7.51989L9.30104 3.19887C9.02538 2.93371 8.57844 2.93371 8.30278 3.19887C8.02711 3.46403 8.02711 3.89394 8.30278 4.1591L11.59 7.32102H2.70588C2.31603 7.32102 2 7.62501 2 8C2 8.37499 2.31603 8.67898 2.70588 8.67898H11.59L8.30278 11.8409C8.02711 12.1061 8.02711 12.536 8.30278 12.8011C8.57844 13.0663 9.02538 13.0663 9.30104 12.8011L13.7933 8.48011Z" fill="#252628"/>
                            </svg>
                        </a>
                    </div>
                </div>
                
            </a>
            <a class="zemlya-banners__right-block" :href="bannerInfo.right_bottom.props.link.value">
                <picture class="zemlya-banners__picture">
                    <source
                        media="(max-width: 600px)"
                        :srcset="bannerInfo?.right_bottom?.props?.img_mobile?.files[0]?.src"
                    >
                    <source
                        media="(max-width: 1100px)"
                        :srcset="bannerInfo?.right_bottom?.props?.img_table?.files[0]?.src"
                    >
                    <source
                        media="(min-width: 1101px)"
                        :srcset="bannerInfo?.right_bottom?.props?.img_desktop?.files[0]?.src"
                    >

                    <img 
                        :src="bannerInfo?.right_bottom?.props?.img_desktop?.files[0]?.src"
                        alt="background-right-top-photo"
                        class="zemlya-banners__image"
                    >
                </picture>
                <div class="zemlya-banners__right-content zemlya-banners__content">
                    <h2 class="zemlya-banners__right-title">
                        {{ bannerInfo.right_bottom.props.title.value }}
                    </h2>
                    <div class="zemlya-banners__right-container">
                        <p class="zemlya-banners__right-text">
                            {{ bannerInfo.right_bottom.props.subtitle.value }}
                        </p>
                        <a class="zemlya-banners__right-link" :href="bannerInfo.right_bottom.props.link.value">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7933 8.48011C14.0689 8.21495 14.0689 7.78505 13.7933 7.51989L9.30104 3.19887C9.02538 2.93371 8.57844 2.93371 8.30278 3.19887C8.02711 3.46403 8.02711 3.89394 8.30278 4.1591L11.59 7.32102H2.70588C2.31603 7.32102 2 7.62501 2 8C2 8.37499 2.31603 8.67898 2.70588 8.67898H11.59L8.30278 11.8409C8.02711 12.1061 8.02711 12.536 8.30278 12.8011C8.57844 13.0663 9.02538 13.0663 9.30104 12.8011L13.7933 8.48011Z" fill="#252628"/>
                            </svg>
                        </a>
                    </div>
                </div>
            </a>
        </div>
    </section>
</template>

<script>
import { defineProps } from "vue";

export default {
	name: 'ZemlyaBanners',
    props: ['banner-info'],
}
</script>

<script setup>
const props = defineProps(['banner-info']);
const bannerInfo = props.bannerInfo.sections
</script>